import { render, staticRenderFns } from "./CustomStyle.vue?vue&type=template&id=0cf8677c&scoped=true"
import script from "./CustomStyle.vue?vue&type=script&lang=js"
export * from "./CustomStyle.vue?vue&type=script&lang=js"
import style0 from "./CustomStyle.vue?vue&type=style&index=0&id=0cf8677c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf8677c",
  null
  
)

export default component.exports